import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Icon from '@components/custom/Icon';
import ModuleHeader from '@components/ModuleHeader';
import ScrollList from '@components/custom/ScrollList';
import Select from '@components/custom/Select';
import Spinner from '@components/custom/Spinner';

import '@assets/css/finances.css';
import ERC20 from '@assets/images/erc20.png';
import TRC20 from '@assets/images/trc20.png';

import { crudActions } from '@sm/services/crudActions';
import { showAlert } from '@sm/store/alertSlice';
import { useClipboard } from '@sm/hooks/useClipboard';
import { formatBalance } from '@sm/utils/utils';

const TopUpCrypto = () => {
  const dispatch = useDispatch();
  const copyToClipboard = useClipboard();

  const [isLoading, setIsLoading] = useState(true);
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState('');
  const [selectedWallet, setSelectedWallet] = useState('');
  const [wallets, setWallets] = useState([]);
  const [walletBalance, setWalletBalance] = useState(0);
  const [/*qrCode*/, setQrCode] = useState(null);
  const [walletAddress, setWalletAddress] = useState('');

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    crudActions.get('v1/clients/lookups/wallet-top-up')
      .then(response => {
        if (isMounted && response) {
          const currenciesList = Object.keys(response?.dataList).map(item => ({ label: item.replace('_', ' '), value: item }));
          setCurrencies(currenciesList);
          setSelectedCurrency(currenciesList[0]?.value);
          setWallets(response?.dataList);
        }
      })
      .catch(err => {
        if (isMounted) dispatch(showAlert('danger', err?.message));
      })
      .finally(() => {
        if (isMounted) setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, [dispatch]);

  useEffect(() => {
    if (!selectedWallet) return;

    setIsLoading(true);
    crudActions.get(`v1/merchant-balance/wallet/${selectedWallet}?currency=${selectedCurrency}`)
      .then(response => {
        setWalletBalance(response?.balance);
        setQrCode(response?.qr);
        setWalletAddress(response?.address);
      })
      .catch(err => {
        dispatch(showAlert('danger', err?.message));
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [selectedWallet, selectedCurrency, dispatch]);

  const handleCurrencyClick = (value) => {
    setSelectedCurrency(value);
    setSelectedWallet('');
    setWalletBalance(0);
  };

  return (
    <div className='col-12 module finances topUp crypto'>
      <div className='component shadow mb-4 position-relative'>
        <ModuleHeader
          id='send_money'
          title='Top-Up Crypto Wallet'
          actions={
            <ScrollList
              items={ currencies }
              selectedItem={ selectedCurrency }
              onClick={ (value) => handleCurrencyClick(value) }
            />
          }
        />

        {isLoading && <Spinner /> }

        <div className='row d-flex align-items-stretch info'>
          <div className='col-sm-12 col-lg-5 item-wrap'>
            <div className='item item1'>
              <div className='header'>
                <Icon name='account_balance_wallet' />
                Select Wallet
              </div>
              <div className='body flex-row align-items-center justify-content-between'>
                <div className='select-wrapper'>
                  <Select
                    id="wallet"
                    name="wallet"
                    label="Wallet"
                    value={ selectedWallet }
                    required={ true }
                    clearable={ false }
                    disabled={ isLoading }
                    onChange={ (e) => setSelectedWallet(e.value) }
                    options={ wallets[selectedCurrency] }
                  />
                </div>
                <div className='balance'>
                  <span className='currency'>{ selectedCurrency.replace('_', ' ') }</span>
                  <span className='number'>{ formatBalance(walletBalance) }</span>
                </div>
              </div>
              <div className='arrow'>
                <Icon name='keyboard_double_arrow_right' style={ { marginRight: 0 } } color='#8a8a8a' />
              </div>
            </div>
          </div>
          <div className='col-sm-12 col-lg-7 mt-md-3 mt-lg-0 item-wrap'>
            <div className='item item2 d-flex align-items-center'>
              {selectedWallet && (
                <div className='body d-flex justify-content-between align-items-center'>
                  <div className='wallet-details'>
                    <div className='d-flex'>
                      <img src={ selectedCurrency.includes('TRC') ? TRC20 : ERC20 } alt={ selectedCurrency } />
                      <div>
                        <div className='wallet-currency'>
                          { selectedCurrency.split('_')[1] }&nbsp;{ selectedCurrency.split('_')[0] }
                        </div>
                        <div className='wallet-address'>
                          { walletAddress }
                          <Icon name='content_copy' size={ 18 } onClick={ () => copyToClipboard(walletAddress) } />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className='d-flex align-items-center mt-3 mt-md-0'>
                    {/* <div className='qr-code'>
                      <img src={ qrCode } alt={ walletAddress } />
                    </div> */}
                    <div className='d-flex flex-column align-items-center text-center notice'>
                      <Icon name='emergency_home'/>
                      <div>
                        Be careful to only send <span>{ selectedCurrency.split('_')[0] }</span> via <span>{ selectedCurrency.split('_')[1] }</span> blockchain
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopUpCrypto;